import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import Done from '@material-ui/icons/Done';
import _ from 'lodash';
import { Link } from "react-router-dom";
import {connect} from "react-redux";
import {actions} from "../../actions";

const actionsStyles = theme => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing.unit * 2.5,
    },
});

class TablePaginationActions extends React.Component {

    handleBackButtonClick = event => {
        this.props.onChangePage(event, this.props.page - 1);
    };

    handleNextButtonClick = event => {
        this.props.onChangePage(event, this.props.page + 1);
    };


    render() {
        const {classes, count, page, rowsPerPage, theme} = this.props;

        return (
            <div className={classes.root}>

                <IconButton
                    onClick={this.handleBackButtonClick}
                    disabled={page === 0}
                    aria-label="Previous Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowRight/> : <KeyboardArrowLeft/>}
                </IconButton>
                <IconButton
                    onClick={this.handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Next Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowLeft/> : <KeyboardArrowRight/>}
                </IconButton>

            </div>
        );
    }
}

TablePaginationActions.propTypes = {
    classes: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    theme: PropTypes.object.isRequired,
};

const TablePaginationActionsWrapped = withStyles(actionsStyles, {withTheme: true})(
    TablePaginationActions,
);

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    table: {
        minWidth: 500,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    button: {
        margin: theme.spacing.unit,
    }
});

class ReviewTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            rowsPerPage: 10
        };
    };

    handleChangePage = (event, page) => {
        this.setState({page}, () => {
            let query = {
                unid: this.props.user.unid,
                page: page+1,
                limit: this.state.rowsPerPage
            }
            this.props.fetchReviews(query);
        });
    };

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.reviews !== nextProps.reviews;
    }

    handleChangeRowsPerPage = event => {
        let query = {
            unid: this.props.user.unid,
            page: this.state.page+1,
            limit: event.target.value
        }
        this.props.fetchReviews(query).then(()=>{
            this.setState({rowsPerPage: event.target.value})
        });
    };


    renderTerms(terms) {
        let stringTerms =  _.map(terms, option => {
            return option.name;
        });
        let str = stringTerms.toString();
        return str.replace(/,/g, ', ');
    }
    componentDidMount() {
        let query = {
            unid: this.props.user.unid,
            page: this.state.page+1,
            limit: this.state.rowsPerPage
        }

        this.props.fetchReviews(query);
    }

    renderRows(list) {
        if(list.docs) {
            return _.map(list.docs, row => {
                var reviewerObject = row.reviewers.filter(reviewer => {
                    return reviewer.unid === this.props.user.unid;
                })
                let reviewed = '';
                if(reviewerObject[0].finished) {
                    reviewed = <Done/>
                }
                return (
                    <TableRow key={row._id}>
                        <TableCell component="th" scope="row">
                            <Link style={{color: '#000', textDecoration: 'underline', fontWeight: '700'}} to={`/review/${row._id}`}>
                                {row.name}
                            </Link>
                        </TableCell>
                        <TableCell>{row.program.name}</TableCell>
                        <TableCell>{row.department.name}</TableCell>
                        <TableCell>{this.renderTerms(row.terms)}</TableCell>
                        <TableCell>{reviewed}</TableCell>
                    </TableRow>
                );
            })
        }
    }

    render() {

        const { classes } = this.props;
        let emptyRows = this.state.rowsPerPage;

        return (
            <Paper className={classes.root}>
                <div className={classes.tableWrapper}>
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell>Assessment</TableCell>
                                <TableCell>Program</TableCell>
                                <TableCell>Department</TableCell>
                                <TableCell>Semester</TableCell>
                                <TableCell>Completed</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.renderRows(this.props.reviews)}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    colSpan={5}
                                    count={this.props.reviews.total || 0}
                                    rowsPerPage={this.props.reviews.limit || 0}
                                    page={this.state.page}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    ActionsComponent={TablePaginationActionsWrapped}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </div>
            </Paper>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        reviews: state.reviews,
        reviewers: state.reviewers
    };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(ReviewTable));


